export default function miniLightbox() {
    // Open lightbox on click
    document.querySelectorAll('.data-open, .link-overlay, .link-overlay a, [data-open]').forEach(function(el) {
        el.addEventListener('click', function(event) {
            let target = el.getAttribute('data-open');
            document.body.classList.add('modal-active');
            document.querySelector(target).setAttribute('data-visible', 'true');
            document.querySelector(target).closest('.box-overlay').classList.add('is-active');
            console.log("Modal clicked: "+target);
        });
    });

    // Close lightbox on click
    document.querySelectorAll(".box-overlay .close, .box-overlay .box-close, .box-overlay .bg-close").forEach(function(el) {
        el.addEventListener('click', function(event) {
            document.body.classList.remove('modal-active');
            document.querySelectorAll('[data-visible]').forEach(function(el) {
                el.removeAttribute('data-visible');
            });
            this.closest('.box-overlay').classList.remove('is-active');
        });
    });
}
